import { render, staticRenderFns } from "./DashboardSmartInsights.vue?vue&type=template&id=61e7d9b4&scoped=true"
import script from "./DashboardSmartInsights.vue?vue&type=script&lang=js"
export * from "./DashboardSmartInsights.vue?vue&type=script&lang=js"
import style0 from "./DashboardSmartInsights.vue?vue&type=style&index=0&id=61e7d9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7d9b4",
  null
  
)

export default component.exports